import { render } from "./IncomeStatement.vue?vue&type=template&id=1adda56e&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"

import "./IncomeStatement.vue?vue&type=style&index=0&id=1adda56e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adda56e"]])

export default __exports__